import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

const UpdateInventoryPopup = ({ open, handleClose, data, onUpdate }) => {
    const [formData, setFormData] = useState({
        medicineName: '',
        quantity: '',
        price: '',
        laboratory: '',
    });

    // Preload data when the popup opens
    useEffect(() => {
        if (data) {
            setFormData({
                medicineName: data.medicineName || '',
                quantity: data.quantity || '',
                price: data.price || '',
                laboratory: data.laboratory || '',
            });
        }
    }, [data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        try {
            const payload = {
                name: formData.medicineName,
                stock: Number(formData.quantity),
                price: Number(formData.price),
                specifications: {
                    laboratory: formData.laboratory,
                },
            };

            // Usando data._id en lugar de data.medicineId
            console.log("Saving update for product with id:", data._id);
            const response = await fetch(`https://apipro.intern.saludti.es/model/product/${data._id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                const errorText = await response.text();
                console.error('Error response:', errorText);
                throw new Error('Error updating product');
            }
            const updatedProduct = await response.json();
            onUpdate(updatedProduct);
            handleClose();
        } catch (error) {
            console.error('Error updating product:', error);
            alert("Error updating product");
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Update Product</DialogTitle>
            <DialogContent>
                <TextField
                    margin="dense"
                    label="Medicine Name"
                    name="medicineName"
                    value={formData.medicineName}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    label="Quantity"
                    name="quantity"
                    type="number"
                    value={formData.quantity}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    label="Price"
                    name="price"
                    type="number"
                    value={formData.price}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    label="Laboratory"
                    name="laboratory"
                    value={formData.laboratory}
                    onChange={handleChange}
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained">Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default UpdateInventoryPopup;
